import React from 'react';

const RelatedTab = ({ analysis }) => {
    return (
        <div>
            <h2 className="text-xl font-bold mb-4">Ricerche Correlate</h2>
            {analysis.relatedSearches.length > 0 ? (
                <div className="space-y-3 mb-6">
                    {analysis.relatedSearches.map((search, i) => (
                        <div key={i} className="p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
                            <div className="flex items-center">
                                <span className="text-blue-600 mr-2">🔍</span>
                                <span className="font-medium">{search}</span>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <p className="text-gray-500 mb-6">Nessuna ricerca correlata disponibile</p>
            )}

            {analysis.paaQuestions.length > 0 && (
                <div className="p-4 bg-purple-50 rounded-lg">
                    <h3 className="font-semibold mb-3">Domande Frequenti (People Also Ask)</h3>
                    <ul className="space-y-2 text-sm">
                        {analysis.paaQuestions.map((q, i) => (
                            <li key={i}>• {q}</li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default RelatedTab;
